import Header from './Header';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import CopyRight from '@/common/copyright';
import cookie from 'js-cookie';
import { getIsImpersonating, getStoreData } from '@/redux/app-selectors';
import { useDispatch } from 'react-redux';
import { callToStopImpersonateGlobalAdmin } from '@/redux/app-slice';
import { IMPERSONATING_INFO, STOP_IMPERSONATING, STORE_ACCOUNT } from '@/utils/constants';
import AppConfig from '@/utils/app-config.mjs';
import { useEffect, useRef } from 'react';

const IntercomTracker = () => {
  const hasSetupOnShow = useRef(false);
  
  useEffect(() => {
    // Only set up the onShow event once - NO performance impact during navigation
    if (hasSetupOnShow.current) return;
    
    const setupOnShow = () => {
      if (window?.Intercom) {
        hasSetupOnShow.current = true;
        
        // This ONLY fires when user clicks the Intercom chat widget
        window.Intercom('onShow', () => {
          const currentUrl = window.location.href;
          window.Intercom('update', {
            page_url: currentUrl,
            page_title: document.title,
            updated_at: new Date().getTime()
          });
          
        });
      } else {
        // Retry if Intercom isn't loaded yet
        setTimeout(setupOnShow, 2000);
      }
    };
    
    setupOnShow();
  }, []); // Empty dependency array - runs once only!
  
  return null;
};
export default function Outer() {
  const storeDetails = getStoreData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onClickStopImpersonate = () => {
    dispatch(callToStopImpersonateGlobalAdmin({navigate}));
  }
  const isImpersonating = getIsImpersonating();
  const isGlobalAdminImpersonating = () => {
    return cookie.get(AppConfig.cookieStoreIdName) && isImpersonating;
  }
  return (
    <div className={'Outer'}>
      {
        (isGlobalAdminImpersonating() && storeDetails.name) && (
          <>
            <div className='imperonate-header'>
              <p>{IMPERSONATING_INFO} <span>‘{storeDetails.name}’</span> {STORE_ACCOUNT}</p>
              <button onClick={onClickStopImpersonate}>{STOP_IMPERSONATING}</button>
            </div>
          </>
        )
      }
      <Header />
      <Box className="content-container">
        <IntercomTracker />
        <Outlet />
      </Box>
      <CopyRight />
    </div>
  );
}
